export default function() {
  return new Worker(__webpack_public_path__ + "static/js/worker.0db894ce.worker.js");
}
